//所有有关用户信息的网络请求
import http from "../utils/http";

//查询所有该用户管理的数据
export function apireviewList({ page, size }) {
  return http({
    url: "/review/all",
    method: "get",
    params: {
      page: page,
      size: size,
    },
  });
}

//新增
export function apiAddReviewList(data) {
  return http({
    url: "/review",
    method: "POST",
    data,
  });
}

//编辑
export function apiEditReviewList({ id, data }) {
  return http({
    url: `/review/${id}`,
    method: "put",
    data,
  });
}

//删除
export function apiDeleteReviewList(id) {
  return http({
    url: `/review/${id} `,
    method: "delete",
  });
}

//多条件分页查询
export function apiReviewSearch(params) {
  return http({
    url: `/review`,
    method: "get",
    params: params,
  });
}

//导入
export function apiImportFile(params){
  return http({
    url:'/review/upload',
    method:'post',
    data:params,
    headers:{
      'content-type':'multipart/form-data'
    }
  })
}

// 导出评论管理
export function apiCommentsExport(params){
  return http({
    url:`/review/download`,
    method:'get',
    params:params,
    responseType: 'blob'
  })
}

